import * as React from "react";
import "../../style/fonts.css";
import "./regFacebook.css";
import Checkbox from "../checkbox/checkbox";
import CtaButton from "../ctaButton/ctaButton";
import Input from "../input/input";
import {
  createProfile,
  createUser,
  resetFaceNewUserAndProfile,
} from "src/store/actions/authActions";
import { createEmptyProfile } from "../../functions/createProfile";
import { createEmptyUser } from "../../functions/createUser";
import {
  checkUsername,
  resetUsernameWarning,
  setUsernameDuplicateWarning,
} from "src/store/actions/regActions";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import translate from "../../translations/i18n";
import detectBrowserLanguage from "detect-browser-language";
import myConfig from "../../firebase/config.json";
import { couldStartTrivia } from "typescript";
import { duplicateSearch } from "../../functions/searchApis";

export function isUsernameTaken(users: any[]) {
  return users.some((user) => {
    return user.env === myConfig.projectId;
  });
}

export interface Props {
  createProfile(emptyProfile): void;
  createUser(emptyUser): void;
  checkUsername: (username, minLength, maxLength) => void;
  resetFaceNewUserAndProfile(): void;
  resetUsernameWarning: () => void;
  setUsernameDuplicateWarning: () => void;

  authError: any;
  auth: any;
  uid: any;
  usernameError: string;
  regFaceError: any;
  createUserCompleted: any;
  createProfileCompleted: any;
}

interface State {
  username: string;
  conditionAds: boolean;
  conditionTerms: boolean;
  usernameWarning: any;
  nullUsername: boolean;
}

class RegFacebook extends React.Component<any, State> {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      conditionAds: false,
      conditionTerms: false,
      usernameWarning: null,
      nullUsername: true,
    };

    this.register = this.register.bind(this);
    this.acceptConditionAds = this.acceptConditionAds.bind(this);
    this.acceptConditionTerms = this.acceptConditionTerms.bind(this);
  }

  componentDidMount() {
    this.props.resetUsernameWarning();
  }

  handleChangeUsername(event) {
    this.setState({ username: event.target.value });
    this.props.checkUsername(event.target.value, 3, 18);
    this.usernameErrorCheck(event.target.value);
  }

  usernameErrorCheck(username) {
    if (username) this.setState({ nullUsername: false });
    else this.setState({ nullUsername: true });
  }

  acceptConditionAds() {
    this.setState((prevState) => ({
      conditionAds: !prevState.conditionAds,
    }));
  }

  acceptConditionTerms() {
    this.setState((prevState) => ({
      conditionTerms: !prevState.conditionTerms,
    }));
  }

  infoConditionAds = () => {
    const lang = String(detectBrowserLanguage()).includes("de") ? "de" : "en";
    const url = "https://static.smokeless.world/" + lang + "/manual.html";
    this.openUrl(url);
  };

  infoConditionTerms = () => {
    const lang = String(detectBrowserLanguage()).includes("de") ? "de" : "en";
    const url = "https://static.smokeless.world/" + lang + "/terms.html";
    this.openUrl(url);
  };

  openUrl(url: string) {
    const win = window.open(url, "_blank");
    if (win != null) {
      win.focus();
    }
  }

  async register() {
    this.props.checkUsername(this.state.username, 3, 18);
    if (this.state.conditionTerms && !this.props.usernameError) {
      duplicateSearch(this.state.username)
        .then((result) => {
          console.log(result);
          if (!isUsernameTaken(result)) {
            this.props.registerWithEmail(this.state);
          } else {
            this.props.setUsernameDuplicateWarning();
          }
        })
        .catch(() => {
          this.props.setUsernameDuplicateWarning();
        });
    }
  }

  componentDidUpdate() {
    if (
      this.props.createUserCompleted === true &&
      this.props.createProfileCompleted === true
    ) {
      this.props.resetFaceNewUserAndProfile();
    }
  }

  checkButton = () => {
    if (
      this.state.username != "" &&
      !this.props.usernameError &&
      this.state.conditionTerms
    ) {
      return false;
    } else {
      return true;
    }
  };

  render() {
    if (
      this.props.createUserCompleted === true &&
      this.props.createProfileCompleted === true
    ) {
      return <Redirect to="/registerProgress" push />;
    }
    return (
      <div className="REGFACEBOOK">
        <div className="REG_TITLE">
          <div className="TITLE_2">
            {translate("SUPPORT_REGISTER_AND_LOGIN_TITLE")}
          </div>
        </div>
        <div className="USERNAME_INPUT">
          <Input
            type={"text"}
            placeholder={translate("USERNAME_FORM")}
            value={this.state.username}
            onChange={this.handleChangeUsername.bind(this)}
            warning={
              this.props.usernameError && translate(this.props.usernameError)
            }
            passwordSeen={null}
          />
        </div>
        <div className="CHECKBOX_3">
          <div className="CHECK_AREA">
            <Checkbox
              text={translate("CONDITIONS_ADS")}
              checked={this.state.conditionAds}
              onClick={this.acceptConditionAds.bind(this)}
              onClickInfo={this.infoConditionAds}
            />
          </div>
        </div>
        <div className="CHECKBOX_4">
          <div className="CHECK_AREA">
            <Checkbox
              text={translate("CONDITIONS_TERMS")}
              checked={this.state.conditionTerms}
              onClick={this.acceptConditionTerms.bind(this)}
              onClickInfo={this.infoConditionTerms}
            />
          </div>
        </div>
        <div className="CREATE_ACCBUTTON_AREA">
          <div className="CREATE_ACCBUTTON">
            <CtaButton
              width={"280px"}
              text={translate("CTA_CREATE_NEW_ACCOUNT")}
              color={"grey"}
              disabled={this.checkButton()}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authError: state.auth.authError,
    auth: state.firebase.auth,
    uid: state.firebase.auth.uid,
    usernameError: state.reg.usernameError,
    regFaceError: state.auth.faceRegerror,
    createUserCompleted: state.auth.createUserCompleted,
    createProfileCompleted: state.auth.createProfileCompleted,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createProfile: (emptyProfile) => dispatch(createProfile(emptyProfile)),
    createUser: (emptyUser) => dispatch(createUser(emptyUser)),
    checkUsername: (username, minLength, maxLength) =>
      dispatch(checkUsername(username, minLength, maxLength)),
    resetUsernameWarning: () => dispatch(resetUsernameWarning()),
    setUsernameDuplicateWarning: () => dispatch(setUsernameDuplicateWarning()),
    resetFaceNewUserAndProfile: () => dispatch(resetFaceNewUserAndProfile()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegFacebook);



// WEBPACK FOOTER //
// ./src/components/Registration/regFacebook.tsx